import { ThemeProvider, CssBaseline } from "@mui/material";
import { baseTheme } from "./assets/global/Theme-variable";
import { useRoutes } from "react-router-dom";
import privateRoutes from "./Routes/privateRoutes";
import publicRoutes from "./Routes/publicRoutes";
import { ToastProvider } from "use-toast-mui";
import React, { Suspense } from "react";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

function App() {
  const isAuthenticated = Boolean(window.localStorage.getItem("access_token"));

  const routing = useRoutes(
    isAuthenticated ? privateRoutes : publicRoutes
  );

  return (
    <ThemeProvider theme={baseTheme}>
      <CssBaseline />
      <ToastProvider>
        <Suspense fallback={null}>
          {routing}
        </Suspense>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
